import axios from "axios";
import { getKeycloackToken } from "./auth";
import * as types from "../constants/collectionConstants";
import { getCookie, setCookie } from "../../common/cookie_helper";

export const createCollection = async (collection) => {
  let _orgId = getCookie("org_id");
  var data = new FormData();

  data.append("collectionName", collection?.name);
  data.append("collectionDescription", collection?.collectionDescription);
  data.append("jsonFields", "");
  // data.append("response_language", collection?.response_language||"en");

  let token = await getKeycloackToken();
  var config = {
    method: "post",
    url: `${process.env.REACT_APP_SUPER_KNOWLEDGE_BASE_URL}/app/CreateCollection`,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
      "x-orgId": _orgId,
    },
    data: data,
  };

  try {
    let status = await axios(config);
    return status;
  } catch (err) {
    console.log("Error while creating collection", err.message);
  }
};

export const uploadDocument = async (collectionName, file, fileURL) => {
  try {
    let _orgId = getCookie("org_id");
    let token = await getKeycloackToken();
    let data = new FormData();
    data.append("document", file);
    data.append("collectionName", collectionName);
    const fileDetails = file?.name?.split(".");
    data.append("jsonData", "");
    data.append("documentName", fileDetails[0]);
    //data.append("fileUrl", fileURL);

    var config = {
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/collection/UploadDocument?fileURL=${fileURL}`,
      method: "post",
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
        "x-orgId": _orgId,
      },
      data: data,
    };
    let result = await axios(config);
    return result;
  } catch (e) {
    console.log("error", "Something went wrong");
  }
};

export const uploadUrl = async (collectionName, url, resourceName) => {
  try {
    let _orgId = getCookie("org_id");

    let token = await getKeycloackToken();
    let data = new FormData();
    data.append("document", url);
    data.append("collectionName", collectionName);
    data.append("jsonData", "");
    data.append("documentName", resourceName);
    data.append("fileUrl", url);

    var config = {
      url: `${process.env.REACT_APP_SUPER_KNOWLEDGE_BASE_URL}/app/v1_1/UploadDocument`,
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "x-orgId": _orgId,
      },
      data: data,
    };
    let result = await axios(config);
    return result;
  } catch (e) {
    console.log("error", "Something went wrong");
  }
};

export const deleteCollection = async (collectionName) => {
  try {
    let _orgId = getCookie("org_id");

    let token = await getKeycloackToken();
    let data = new FormData();

    data.append("collectionName", collectionName);

    var config = {
      url: `${process.env.REACT_APP_SUPER_KNOWLEDGE_BASE_URL}/app/DeleteCollection`,
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "x-orgId": _orgId,
      },
      data: data,
    };
    let result = await axios(config);
    return result;
  } catch (e) {
    console.log("error", "Something went wrong");
  }
};

export const queryDocument = async (
  question,
  collectionName,
  docName,
  chatContext
) => {
  try {
    let _orgId = getCookie("org_id");

    let token = await getKeycloackToken();
    let data = new FormData();
    data.append("question", question);
    data.append("collectionName", collectionName);
    data.append("jsonData", "");
    data.append("documentName", docName);
    data.append("chat_context", chatContext);

    var config = {
      url: `${process.env.REACT_APP_SUPER_KNOWLEDGE_BASE_URL}/app/QueryDocument`,
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "x-orgId": _orgId,
      },
      data: data,
    };
    let result = await axios(config);
    return result?.data;
  } catch (e) {
    console.log("error", "Something went wrong");
  }
};

export const getChatGPT = async (question) => {
  try {
    let data = new FormData();
    data.append("id", "");
    data.append("context", "");
    data.append("uid", "");
    data.append("message", question);
    data.append("url", "");
    data.append("title", "");

    var config = {
      url: `${process.env.REACT_APP_CHAT_GPT_URL}/app/CGPT_Api`,
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    let result = await axios(config);
    return result?.data?.response;
  } catch (e) {
    console.log("error", "Something went wrong");
  }
};

export const getCollections = async () => {
  let _orgId = getCookie("org_id");

  let token = await getKeycloackToken();
  var config = {
    method: "get",
    url: `${process.env.REACT_APP_SUPER_KNOWLEDGE_BASE_URL}/app/ListCollections`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "x-orgId": _orgId,
    },
  };

  try {
    let { data } = await axios(config);
    return data;
  } catch (err) {
    console.log("Error while retrieving", err.message);
  }
};

export const getTrainedData = (collectionName) => async (dispatch) => {
  let _orgId = getCookie("org_id");

  let token = await getKeycloackToken();
  var config = {
    method: "get",
    url: `${process.env.REACT_APP_SUPER_KNOWLEDGE_BASE_URL}/app/GetUpdateLog?collectionName=${collectionName}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "X-Orgid": _orgId,
    },
  };

  try {
    let { data } = await axios(config);
    dispatch({
      type: types.GET_TRAINED_DATA,
      trainedData: data.data,
    });
  } catch (err) {
    console.log("Error while retrieving", err.message);
  }
};

export const deleteTrainedData =
  (collectionName, questionId, question) => async (dispatch) => {
    let _orgId = getCookie("org_id");

    let token = await getKeycloackToken();

    let data = new FormData();
    data.append("question", question);
    data.append("collectionName", collectionName);
    data.append("jsonData", "");
    data.append("updated_question_id", questionId);

    var config = {
      method: "post",
      url: `${process.env.REACT_APP_SUPER_KNOWLEDGE_BASE_URL}/app/DeleteUpdateDocument`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "X-Orgid": _orgId,
      },
      data: data,
    };

    try {
      let { data } = await axios(config);
      dispatch({
        type: types.DELETE_TRAINED_DATA,
        trainedData: data.data,
      });
    } catch (err) {
      console.log("Error while retrieving", err.message);
    }
  };

export const getDocUploadStatus = async (docName, collectionName) => {
  let _orgId = getCookie("org_id");

  let token = await getKeycloackToken();
  var config = {
    method: "get",
    url: `${process.env.REACT_APP_SUPER_KNOWLEDGE_BASE_URL}/app/GetUploadStatus?document_name=${docName}&collectionId=${collectionName}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "x-orgId": _orgId,
    },
  };

  try {
    let { data } = await axios(config);
    return data?.response[0];
  } catch (err) {
    console.log("Error while retrieving", err.message);
    return { status: false, error: err.message };
  }
};

export const deleteDocument = async (collectionName, docName) => {
  try {
    let _orgId = getCookie("org_id");

    let token = await getKeycloackToken();
    let data = new FormData();
    data.append("collectionName", collectionName);
    data.append("jsonData", "");
    data.append("documentName", docName);

    var config = {
      url: `${process.env.REACT_APP_SUPER_KNOWLEDGE_BASE_URL}/app/DeleteDocument`,
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "x-orgId": _orgId,
      },
      data: data,
    };
    let result = await axios(config);
    return result?.data;
  } catch (e) {
    console.log("error", "Something went wrong");
  }
};

export const exportCollection = async (collectionName, dateQuery) => {
  try {
    let _orgId = getCookie("org_id");
    let token = await getKeycloackToken();

    var config = {
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/collection/exportCollection?id=${collectionName}${dateQuery}`,
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "x-orgId": _orgId,
      },
    };
    let result = await axios(config);
    return result;
  } catch (e) {
    console.log("error", "Something went wrong");
  }
};

export const thumbsAction = async (id, is_thumbs_up) => {
  try {
    let _orgId = getCookie("org_id");
    let token = await getKeycloackToken();

    let data = new FormData();
    data.append("id", id);
    data.append("is_thumbs_up", is_thumbs_up);

    var config = {
      url: `${process.env.REACT_APP_SUPER_KNOWLEDGE_BASE_URL}/app/UpdateThumbsUpView`,
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "x-orgId": _orgId,
      },
      data: data,
    };
    let result = await axios(config);
    return result?.data;
  } catch (e) {
    console.log("error", "Something went wrong");
  }
};

export const sendInputAnswer = async (
  collectionName,
  questionId,
  question,
  oldAnswer,
  newAnswer
) => {
  try {
    let _orgId = getCookie("org_id");
    let token = await getKeycloackToken();

    let data = new FormData();
    data.append("collectionName", collectionName);
    data.append("jsonData", "");
    data.append("question_id", questionId);
    data.append("question", question);
    data.append("old_answer", oldAnswer);
    data.append("new_answer", newAnswer);

    var config = {
      url: `${process.env.REACT_APP_SUPER_KNOWLEDGE_BASE_URL}/app/UpdateDocData`,
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "x-orgId": _orgId,
      },
      data: data,
    };
    let result = await axios(config);
    return result?.data;
  } catch (e) {
    console.log("error", "Something went wrong");
  }
};
